import styled from '@emotion/styled';
import { FONT } from '../../styles/emotion';
import H from '../../typography/Headings';

export const StyledHeading = styled(H.TitleBase)`
  color: inherit;

  span,
  strong {
    font-family: ${FONT.FONT_FAMILY_NEW_SPIRIT};
    font-weight: ${FONT.FONT_WEIGHT_MEDIUM};
  }
`;
